import React from "react";
import { Flex, Image, Text, theme, useMediaQuery } from "@chakra-ui/react";
import { ContentBlock } from "@/components/ContentBlock/ContentBlock";
import { useInstanceConfig } from "@/services/InstanceConfigContext";
import { htmlify, interpolatePlaceholders } from "@/services/utils";

export interface SdrProps {
	title: string;
	image: string | undefined;
	disclaimer?: string;
	description?: string;
	tooltip?: string;
}

export const Sdr = React.forwardRef(({ tooltip, title, image, disclaimer, description }: SdrProps, ref) => {
	const instanceConfig = useInstanceConfig();
	const [isMobile] = useMediaQuery(`(max-width: ${theme?.breakpoints?.md || 320})`);

	return (
		<ContentBlock heading={title} tooltip={tooltip}>
			<Flex gap={6} flexDirection={isMobile ? "column" : "row"}>
				<Flex flex={1}>
					<Image src={image} alt={title} maxHeight={130} />
				</Flex>
				<Flex flex={1}>
					<Text as="div">{htmlify(interpolatePlaceholders({ text: disclaimer, instanceConfig }))}</Text>
				</Flex>
			</Flex>
			<Text as="div">{htmlify(description)}</Text>
		</ContentBlock>
	);
});
